export default __webpack_public_path__ + "static/media/home-photography-bg-img-02.ad3916d2.jpg";